<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div *ngIf="isLoading" class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div
      *ngIf="resetRequestComplete && isEmail == true"
      class="card-footer alert alert-success col-12 col-xs-9 col-lg-8"
    >
      {{ globalService.Get("PASSWORD_REQUEST") }}
    </div>
    <div
      class="card SmallForm rounded"
      *ngIf="!isLoading && !resetRequestComplete"
    >
      <div
        class="card-header MyCardHeader rounded-top"
        [class.SmallArabicFont]="globalService.isRTL == true"
      >
        <h2>{{ globalService.Get("RESET_PASSWORD") }}</h2>
      </div>
      <div class="card-body MyCardBody rounded-bottom">
        <div *ngIf="verifyPhone == true">
          <app-phone-verify [dial_code]="dial_code" [portrait]="true" [enabled]="false" [phone_number]="phoneNumber" (failed)="failedVerification()" 
          (clearEvent)="clearCellPhone()" [phoneConfirmed]="false" [userExists]="true" (confirmNumber)="ConfirmCellPhone($event)"></app-phone-verify>  
        </div>
        <form
          *ngIf="resetRequestForm && verifyPhone == false"
          [formGroup]="resetRequestForm"
          (ngSubmit)="onSubmit()"
          autocomplete="off"
          name="dummy"
          [class.SmallArabicFont]="globalService.isRTL == true"
        >
          <div class="row">
            <div
              class="form-group col-12"
              [class.text-right]="globalService.isRTL == true"
            >
              <label for="email">{{ globalService.Get("PHONE_OR_EMAIL") }}</label>
              <input
                type="text"
                id="email"
                dir="ltr"
                class="form-control text-left"
                formControlName="email"
              />
              <small
                class="help-block"
                *ngIf="
                  !resetRequestForm.get('email').valid &&
                  (resetRequestForm.get('email').touched || submit)
                "
                >{{ globalService.Get("VALIDEMAIL") }}</small
              >
            </div>
          </div>
          <div class="form-group" *ngIf="error && !failureClosed">
            <app-user-message
              [type]="'danger'"
              class="text-center"
              (close)="failureClosed = true"
            >
              {{ error }}
            </app-user-message>
          </div>
            <app-prompt-message [showForm]="failedToVerify == true" color="danger"
            (onClose)="failedToVerify = false" message="Failed To Verify Phone!">
            </app-prompt-message>
          <div class="form-group text-center row mt-2">
            <button
              class="btn btn-primary m-auto"
              type="submitReactiveFormsModule"
            >
              {{ globalService.Get("SUBMIT_REQUEST") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
